/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Start_Delivery_ConfirmInputs */

const vi_trip_start_delivery_confirm = /** @type {(inputs: Trip_Start_Delivery_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu`)
};

/**

* @param {Trip_Start_Delivery_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_start_delivery_confirm = /** @type {((inputs?: Trip_Start_Delivery_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Start_Delivery_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_start_delivery_confirm(inputs)
});